import Store from 'lightningjs-redux';
import {
  getCurrentMetadataItem,
  getLastPlaybackError,
  getPlaybackState,
  getVideoSource,
} from '../../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    selector: getPlaybackState,
    callback: value => {
      instance.playbackState = value;
    },
  },
  {
    selector: getVideoSource,
    callback: value => {
      instance.source = value;
    },
    condition: ({ previousProp: prev, currentProp: next }) => prev?.reference !== next?.reference,
  },
  {
    selector: getCurrentMetadataItem,
    callback: value => {
      instance.metadata = value;
    },
  },
  {
    selector: getLastPlaybackError,
    callback: value => {
      instance.playbackError = value;
    },
  },
];

export default Store.control(mapControllers);
